import i18n from "@/core/plugins/i18n";

const getSupportedLocales = () => {
  return process.env.VUE_APP_SUPPORTED_LOCALES?.split(",");
};

const isLocaleSupported = (lang: string) => {
  return getSupportedLocales()?.includes(lang);
};

const getPreferredLocale = () => {
  const lang = window.navigator.language.split("-")[0];
  return isLocaleSupported(lang) ? lang : process.env.VUE_APP_DEFAULT_LOCALE;
};

const getCurrentLocale = () => {
  const selectedLang = window.localStorage.getItem("suits_attorney_lang");
  return (
    selectedLang
      ? isLocaleSupported(selectedLang)
        ? selectedLang
        : process.env.VUE_APP_DEFAULT_LOCALE
      : getPreferredLocale()
  ) as string;
};

const isLocaleRtl = (lang: string) => {
  return process.env.VUE_APP_RTL_LOCALES?.split(",").includes(lang);
};

const setLocale = (lang: string) => {
  const isRtl = isLocaleRtl(lang);

  if (isRtl) {
    setRtlMode();
  } else {
    setLtrMode();
  }

  localStorage.setItem("suits_attorney_lang", lang);
};

const setRtlMode = () => {
  // show page loading
  // store.dispatch(Actions.ADD_BODY_CLASSNAME, "page-loading");

  const link = document.getElementById("main-css");
  link?.setAttribute(
    "href",
    `/css/style.rtl.css?v${process.env.VUE_APP_CACHE_VERSION}`
  );
  document.documentElement.setAttribute("dir", "rtl");
  document.documentElement.setAttribute("direction", "rtl");
  document.documentElement.setAttribute("style", "direction:rtl");

  document.body.style.fontFamily = "Almarai, sans-serif";

  // setTimeout(() => {
  // 	store.dispatch(Actions.REMOVE_BODY_CLASSNAME, "bg-body");
  // }, 1000);
};

const setLtrMode = () => {
  // store.dispatch(Actions.ADD_BODY_CLASSNAME, "page-loading");

  const link = document.getElementById("main-css");
  document.documentElement.removeAttribute("dir");
  document.documentElement.removeAttribute("direction");
  document.documentElement.removeAttribute("style");
  link?.setAttribute(
    "href",
    `/css/style.css?v=${process.env.VUE_APP_CACHE_VERSION}`
  );

  document.body.style.fontFamily = "Inter, sans-serif";

  // setTimeout(() => {
  // 	store.dispatch(Actions.REMOVE_BODY_CLASSNAME, "bg-body");
  // }, 1000);
};

const translate = (text: string, params: any = null) => {
  if (text) {
    return i18n.global.te(text, i18n.global.locale.value)
      ? i18n.global.t(text, params)
      : text;
  }
  return "";
};

export {
  getSupportedLocales,
  isLocaleSupported,
  getPreferredLocale,
  getCurrentLocale,
  setLocale,
  isLocaleRtl,
  setRtlMode,
  setLtrMode,
  translate,
};
